import React, { useState } from "react";
import * as S from './TerminalsMmtStyles'

const TerminalsMmt = ({data}) => {

  const [ footerExpand, setFooterExpand ] = useState(true);
  const {
    source,
    destination
  } = data || {};

  return (
    <S.TerminalsWpr>
      <S.Terminals className={`${footerExpand ? 'expand' : ''}`}>
        <S.Source className={`${footerExpand ? 'expandSource' : ''}`}>
          <S.Label className={`${!footerExpand ? 'ellipsesBefore' : 'ellipsesAfter'}`}>{!footerExpand ? source?.subLabel : source?.label}</S.Label>
          { footerExpand && <S.SubLabel>{source?.subLabel}</S.SubLabel> }
          <S.DateTime>{source?.dateTime}</S.DateTime>
          { footerExpand && <S.ExpandedStops>
              <S.From />
              <S.ExpandedLine />
              <S.To />
          </S.ExpandedStops> }
        </S.Source>
        { !footerExpand && <S.Stops>
            <S.From />
            <S.Line />
            <S.To />
        </S.Stops> }
        <div className="destination">
          <S.Label className={`${!footerExpand ? 'ellipsesBefore' : 'ellipsesAfter'}`}>{!footerExpand ? destination?.subLabel : destination?.label}</S.Label>
          { footerExpand && <S.SubLabel>{destination?.subLabel}</S.SubLabel> }
          <S.DateTime>{destination?.dateTime}</S.DateTime>
        </div>
      </S.Terminals>
      <S.Chevron className={`${footerExpand ? 'chevronExpand' : ''}`} onClick={() => setFooterExpand(prev => !prev)}>
      </S.Chevron>
    </S.TerminalsWpr>
  );
};

export default TerminalsMmt;